import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";
import { ShoppingBag } from "lucide-react";

export default function Merchandising() {
  const { content } = useOutletContext() || {};
  const c = content || {};
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(null);

  useEffect(() => { api.get("/merch").then(r => setItems(r.data)).finally(() => setLoading(false)); }, []);

  const buy = async (p) => {
    if (!p.lookup_key) return toast.error("Prodotto non disponibile per l'acquisto online");
    setBusy(p.id);
    try {
      const { data } = await api.post("/payments/checkout", {
        lookup_key: p.lookup_key, quantity: 1,
        origin_url: window.location.origin,
        metadata: { product_id: p.id, type: "merch" }
      });
      window.location.href = data.checkout_url;
    } catch { toast.error("Errore checkout"); setBusy(null); }
  };

  return (
    <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
      <div className="mb-10">
        <div className="tag-pill mb-3"><ShoppingBag size={12}/> Shop</div>
        <h1 className="font-display text-5xl sm:text-6xl uppercase text-white" data-testid="shop-heading">{c.shop_title || "Merchandising Flow"}</h1>
        <p className="mt-3 text-white/70 whitespace-pre-line">{c.shop_subtitle || ""}</p>
      </div>

      {loading && <div className="text-white/70" data-testid="shop-loading">Caricamento...</div>}
      {!loading && items.length === 0 && <div className="card p-10 text-center text-white/70" data-testid="shop-empty">Nessun prodotto disponibile.</div>}

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {items.map(p => (
          <div key={p.id} className="card overflow-hidden" data-testid={`prod-${p.id}`}>
            <div className="aspect-square bg-black flex items-center justify-center overflow-hidden">
              {p.image_url ? <img src={p.image_url} alt={p.name} className="w-full h-full object-contain"/> :
                <div className="text-white/30 font-display text-4xl">FLOW</div>}
            </div>
            <div className="p-4">
              <h3 className="font-display text-xl uppercase truncate">{p.name}</h3>
              <p className="text-xs text-white/50 mt-1 line-clamp-2">{p.description}</p>
              <div className="mt-3 flex items-center justify-between gap-2">
                {p.price_on_request ? (
                  <span className="tag-pill">Su richiesta</span>
                ) : (
                  <span className="font-mono text-lg text-[#FFFFFF]">€{p.price.toFixed(2)}</span>
                )}
                {p.price_on_request ? (
                  <a href={`/contatti?subject=${encodeURIComponent("Richiesta prezzo: " + p.name)}`}
                    className="brutal-btn brutal-btn-outline text-xs px-3 py-2" data-testid={`info-${p.id}`}>
                    Richiedi
                  </a>
                ) : (
                  <button onClick={() => buy(p)} disabled={busy===p.id || p.stock<=0}
                    className="brutal-btn brutal-btn-primary text-xs px-3 py-2" data-testid={`buy-${p.id}`}>
                    {p.stock<=0 ? "Esaurito" : busy===p.id ? "..." : "Acquista"}
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
